import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import * as config from '../../config';
import { AuthState, setUser } from "../state/authSlice";







const baseQuery = fetchBaseQuery({
  baseUrl: config.base_api_url,
  prepareHeaders: (headers, { getState }) => {
    let accessToken = localStorage.getItem("token") || '';
    if (accessToken) {
      headers.set('Content-Type', `application/json`);
      headers.set('authorization', `Bearer ${accessToken}`);
    }
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result?.error?.status === 401) {
    const refreshResult: any = await baseQuery({
      url: 'v1/auth/refresh/',
      method: 'POST',
      body: {
        refreshToken: localStorage.getItem("refreshToken") || ''
      }
    }, api, extraOptions);

    console.log('refreshResult.data: ', refreshResult.data);
    if (refreshResult.data) {
      api.dispatch(setUser({
        token: refreshResult?.data?.token?.access_token as string,
        user: refreshResult?.data?.user,
        refreshToken: refreshResult?.data?.token?.refresh_token as string
      }));
      localStorage.setItem("token", refreshResult?.data?.token?.access_token);
      localStorage.setItem("refreshToken", refreshResult?.data?.token?.refresh_token);
      localStorage.setItem("user", JSON.stringify(refreshResult?.data?.user));

      // retry the initial query
      result = await baseQuery(args, api, extraOptions);
    } else {
      localStorage.clear();
      api.dispatch(setUser({ token: '', user: null, refreshToken: '' }));
      window.location.replace('/signin');
    }
  }
  return result;
};

// Define a service using a base URL and expected endpoints
export const reAuthApi = createApi({
  reducerPath: "reAuthApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Product"],
  endpoints: (builder) => ({
    changePassword: builder.mutation({
      query: (body: { newPassword: string, currentPassword: string, }) => {
        return {
          url: "v1/auth/change-password",
          method: "post",
          body,
        };
      },
    }),

    signOutUser: builder.mutation({
      query: () => {
        return {
          url: "v1/auth/logout",
          method: "get",
        };
      },
    }),

    getProducts: builder.mutation({
      query: ({page, search, ean}) => {
        let params: any = {page};
        if(search) {
          params = {...params, search};
        }
        if(ean) {
          params = {...params, ean};
        }
        return {
          url: "v1/products",
          method: "get",
          params: {...params}
        };
      },
      invalidatesTags: ["Product"],
    }),
    getProductById: builder.mutation({
      query: (id) => {
        return {
          url: `v1/products/${id}`,
          method: "get",
        };
      },
      invalidatesTags: ["Product"],
    }),
    getMonitoringProducts: builder.mutation({
      query: (id: string = '') => {
        return {
          url: `v1/products/ids/monitored`,
          method: "get",
        };
      },
      // invalidatesTags: ["Product"],
    }),
    addMonitoringProducts: builder.mutation({
      query: (body: { ids: number[] }) => {
        console.log('body: ', body);
        return {
          url: `v1/products/ids/monitored`,
          method: "post",
          body
        };
      },
      // invalidatesTags: ["Product"],
    }),
    deleteMonitoringProduct: builder.mutation({
      query: (id: number) => {
        return {
          url: `v1/products/ids/monitored/${id}`,
          method: "delete",
        };
      },
      // invalidatesTags: ["Product"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useChangePasswordMutation,
  useSignOutUserMutation,
  useGetProductsMutation,
  useGetProductByIdMutation,
  useGetMonitoringProductsMutation,
  useAddMonitoringProductsMutation,
  useDeleteMonitoringProductMutation,
} = reAuthApi;
